import React, {useContext, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {Checkbox, FormControlLabel, FormGroup, IconButton, InputAdornment, TextField} from '@mui/material';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Visibility from '@mui/icons-material/Visibility';
import {AxiosResponse} from 'axios';

import {Divider} from './registerModal.styled';
import {PasswordLine, PasswordPassedLine, Val} from './registerModal.styled';
import closeIcon from '../images/close.svg';
import {registerService} from '../../services/register.service';
import useSnackBar from '../../hooks/useSnackBar';
import {AuthContext} from '../../context/AuthProvider';
import {authService} from '../../services/auth.service';


function RegisterModal({close, openAuth}: any) {
    const {setSnackBar} = useSnackBar();
    const {setAuthenticated} = useContext(AuthContext);
    const [passed, setPassed] = useState(0);
    const navigate = useNavigate();
    const [fields, setFields] = useState({
        name: '',
        email: '',
        password: '',
        password2: ''
    });
    const [validation, setValidation] = useState<string[]>([]);
    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const check = () => {
        const tempValidation = []

        if (!fields.name.length || fields.name.split(' ').length < 2) {
            tempValidation.push('name')
        }

        if (fields.password.length < 8) {
            tempValidation.push('password')
        }

        if (fields.password !== fields.password2) {
            tempValidation.push('password2')
        }
        if (!fields.email.match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )?.length) {
            tempValidation.push('email')
        }
        setValidation(tempValidation)

        return !tempValidation.length
    }

    const submit = async () => {
        const data = {
            email: fields.email.toLocaleLowerCase().replace(/ /g, ''),
            password: fields.password,
            last_name: fields.name.split(' ')?.[0],
            first_name: fields.name.split(' ')?.[1],
            patronymic: fields.name.split(' ')?.[2],
        }
        if (check()) {
            await registerService.register(data).then(data => {
                localStorage.setItem('token', data.data.id);
                close()
                setSnackBar({title: 'success', isActive: true, status: 'success'})
            }).catch((e) => {
                setSnackBar({title: e.response.data.detail, isActive: true, status: 'error'})
            });
            await authService.login(fields.email, fields.password).then((response: AxiosResponse) => {
                localStorage.setItem('token', response.data.access_token);
                localStorage.setItem('refreshToken', response.data.refresh_token);
                setAuthenticated(true);
                navigate('/profile');
                close();
            }).catch(function (e) {
                setSnackBar({title: e.response.data.detail, isActive: true, status: 'error'});
            });
        }


    }
    const isGood = (password: string) => {
        let regex = [];
        regex.push("[A-Z]"); //Uppercase Alphabet.
        regex.push("[a-z]"); //Lowercase Alphabet.
        regex.push("[0-9]"); //Digit.
        regex.push("[$@$!%*#?&]");

        //Validate for each Regular Expression.
        let test = 0
        for (let i = 0; i < regex.length; i++) {
            if (new RegExp(regex[i]).test(password)) {
                test++
            }
        }
        setPassed(test);
        setPassword(password);
    }


    const [password, setPassword] = useState('');

    const getPasswordText = () => {
        switch (passed) {
            case 0:
                return 'Очень легкий';
            case 1:
                return 'Легкий';
            case 2:
                return 'Средний';
            case 3:
                return 'Надежный';
            case 4:
                return 'Очень надежный';
        }
    }

    return (
        <div className="modal-content">
            <button onClick={() => close()} className="close-btn">
                <img src={closeIcon} alt="close-modal"/>
            </button>
            <FormGroup className="auth-modal-content">
                <h3>Зарегистрируйтесь</h3>
                <div className="to-register-text">
                    Уже есть учетная запись? <span className="to-register-link" onClick={openAuth}>Войти</span>
                </div>
                <TextField label={"Ф. И. О. *"} sx={{marginTop: '32px'}}
                           helperText={validation.includes('name') ? 'Введите ФИО' : ''}
                           error={validation.includes('name')}
                           onChange={(e: any) => {
                               setFields({...fields, name: e.target.value})
                               if (validation.includes('name')) {
                                   setValidation(validation.filter(el => el !== 'name'))
                               }
                           }}/>
                <TextField label={"Электронная почта *"} sx={{marginTop: '32px'}} type="email"
                           helperText={validation.includes('email') ? 'Введите email' : ''}
                           error={validation.includes('email')}
                           onChange={(e: any) => {
                               setFields({...fields, email: e.target.value})
                               if (validation.includes('email')) {
                                   setValidation(validation.filter(el => el !== 'email'))
                               }
                           }}/>
                <Divider/>
                <TextField label={"Придумайте пароль"}
                           helperText={validation.includes('password') ? 'Пароль слишком короткий' : ''}
                           error={validation.includes('password')}
                           onChange={(e: any) => {
                               isGood(e.target.value);
                               setFields({...fields, password: e.target.value});
                               if (validation.includes('password')) {
                                   setValidation(validation.filter(el => el !== 'password'))
                               }
                           }}
                           type={showPassword ? 'text' : 'password'}
                           InputProps={{
                               endAdornment: <InputAdornment position="end">
                                   <IconButton
                                       aria-label="toggle password visibility"
                                       onClick={handleClickShowPassword}
                                       onMouseDown={handleMouseDownPassword}
                                       edge="end"
                                   >
                                       {showPassword ? <VisibilityOff/> : <Visibility/>}
                                   </IconButton>
                               </InputAdornment>
                           }}
                />
                {password && <Val>
                    {Array.from({length: 4}).map((item, index) => {
                        return passed > index ? <PasswordPassedLine key={index}/> : <PasswordLine key={index}/>;
                    })}
                    {getPasswordText()}
                </Val>
                }
                <TextField label={"Повторите пароль"}
                           sx={{marginTop: '32px'}}
                           helperText={validation.includes('password2') ? 'Пароли не совпадают' : ''}
                           error={validation.includes('password2')}
                           onChange={(e: any) => {
                               if (validation.includes('password2')) {
                                   setValidation(validation.filter(el => el !== 'password2'))
                               }
                               setFields({...fields, password2: e.target.value})
                           }}
                           type={showPassword ? 'text' : 'password'}
                           InputProps={{
                               endAdornment: <InputAdornment position="end">
                                   <IconButton
                                       aria-label="toggle password visibility"
                                       onClick={handleClickShowPassword}
                                       onMouseDown={handleMouseDownPassword}
                                       edge="end"
                                   >
                                       {showPassword ? <VisibilityOff/> : <Visibility/>}
                                   </IconButton>
                               </InputAdornment>
                           }}
                />

                <FormControlLabel disableTypography={true} className="agree-checkbox" sx={{
                    alignItems: "flex-start",
                    "span": {paddingTop: 0}

                }} labelPlacement="end" control={<Checkbox defaultChecked/>}
                                  label="Отправляйте мне специальные предложения, персонализированные рекомендации и советы по обучению."/>
                <button className="blue-btn" onClick={() => submit()}>Зарегистрироваться</button>

                <div className="data-agreement">
                    <span>Нажимая на кнопку, вы соглошаетесь с нашими </span>
                    <a href="/">Условиями использования</a> <span>и </span>
                    <a href="/">Политикой конфиденциальности</a>
                </div>

            </FormGroup>
        </div>
    );
}

export default RegisterModal;
